import { Component, OnInit } from '@angular/core';
import { TITLES } from '../../../assets/data';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  title = TITLES;

  readonly YEAR = (new Date()).getFullYear();

  public path: string;
  public param:string;

  constructor(private route: ActivatedRoute,location: Location, router: Router) { 
    router.events.subscribe((val) => {
      this.path = location.path();
      this.path = this.path.substring(1);
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.param = params['header'];
    });
  }
  
  scrollTop() {
    window.scrollTo(0, 0);
  }
}
